export enum BlueprintFieldsTypes {
  INPUT_TEXT = "input_text",
  INPUT_TEL = "input_tel",
  INPUT_PASSWORD = "input_password",
  INPUT_NUMBER = "input_number",
  INPUT_RANGE = "input_range",
  INPUT_DATE = "input_date",
  INPUT_DATETIME = "input_datetime",
  INPUT_RADIO = "input_radio",
  CHECKBOX = "checkbox",
  SELECT = "select",
  TEXTAREA = "textarea",
  IMAGE = "image",
  FILE = "file"
}

export enum ProvisionCategoryCodes {
  SHARED_HOSTING = "shared-hosting",
  DOMAIN_NAMES = "domain-names",
  AUTO_LOGIN = "auto-login",
  SEO = "seo",
  WEBSITE_BUILDERS = "website-builders",
  SOFTWARE_LICENSES = "software-licenses",
  SERVERS = "servers"
}

export enum ProvisionFieldTypes {
  PRODUCT_FIELD = "product_field",
  PRODUCT_ATTRIBUTE = "product_attribute"
}

export enum ProvisionRequestActionTypes {
  DISPLAY_RETURN_FIELDS = "display_return_fields",
  FORM_POST = "form_post",
  REDIRECT = "redirect",
  REFRESH_FIELDS = "refresh_fields",
  RENDER_IFRAME = "iframe"
}

export enum ConfigurationModes {
  STATIC = "static",
  DYNAMIC = "dynamic"
}

export enum DeferModes {
  INHERIT = "inherit",
  HIDDEN = "hidden",
  NONE = "none",
  OPTIONAL = "optional"
}
